import { observer } from "mobx-react-lite";
import { FC } from "react";

interface DebugDbPageProps {}

export const DebugDbPage: FC<DebugDbPageProps> = observer(() => {
  return (
    <div>
      <div>Database tools</div>
    </div>
  );
});
